import URL_API_CONSULTAS from "@/shared/utils/ApiUrl/ApiConsultaGestionCasos";
import { HTTP } from "../Http.service";
import type { AlertasByUsuarioRequest, GetAlertaUsuariosInfoResponse, VerificarExistenAlertasResponse } from "@/shared/types/interfaces/ApiConsultaGestionCasos/Actividades.interface";

const http = HTTP(); 

/**
 * Verifica si existen alertas para un usuario, con un parámetro de consulta "visto".
 */
async function VerificarExistenAlertas(data : AlertasByUsuarioRequest): Promise<VerificarExistenAlertasResponse> {
    return await http.Post(`${URL_API_CONSULTAS.VERIFICAR_EXISTEN_ALERTAS}`, {body: data});
}
/**
 * Obtiene información de las alertas de los usuarios.
 */
async function GetAlertaUsuariosInfo(data : AlertasByUsuarioRequest): Promise<GetAlertaUsuariosInfoResponse> {
    return await http.Post(`${URL_API_CONSULTAS.GET_ALERTA_USUARIOS_INFO}`, {body: data});
}

export {
    VerificarExistenAlertas,
    GetAlertaUsuariosInfo
}